var map = {
	"./banhanguytin/5.png": "fd3b",
	"./cacung/5.png": "87b5",
	"./chuyencan/5.png": "2cd7",
	"./daigiadataha/5.png": "bd23",
	"./duhanhgia/5.png": "dda2",
	"./thanhsanma/5.png": "d934"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6a5";